import { render } from "./BankIcon.vue?vue&type=template&id=203b9763"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/BankIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "203b9763"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('203b9763', __exports__)) {
    api.reload('203b9763', __exports__)
  }
  
  module.hot.accept("./BankIcon.vue?vue&type=template&id=203b9763", () => {
    api.rerender('203b9763', render)
  })

}


export default __exports__